import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Zone } from "protos/farm/farm";
import React, { FC } from "react";

interface ObstacleDetailsProps {
  obstacle: Zone;
}
export const ObstacleDetails: FC<ObstacleDetailsProps> = ({ obstacle }) => {
  const { t } = useTranslation();
  return (
    <div className="px-4">
      {obstacle.contents?.obstacle && (
        <Typography variant="h6">
          {t("views.farms.zoneTypes.obstacle")}
        </Typography>
      )}
    </div>
  );
};
